export default function(input, min, max) {
    return _.range(parseInt(min), parseInt(max) + 1);
}
